import React from 'react';
import AlertBlock from '../../../common/AlertBlock';
import Button from '../../../common/Button';
import { getCurrencySymbol, getItemsString } from '../../../../helpers';
import numeral from 'numeral';
import TableRow from '../TableRow';
import SpinnerBlock from '../../../common/SpinnerBlock';
import styled from '@emotion/styled';

const Wrapper = styled('div')`
  th .light {
    font-weight: 400;
  }
  .table tbody {
    border-bottom: 1px solid #dee2e6;
  }
`;

const DekstopComponent = (props) => {
  const {
    data,
    isNew,
    handleNewItem,
    handleRemoveItem,
    loading,
    currentQuantityInput,
    currentQuantityInputValue,
    handleToggleQuantityInput,
    handleUpdateQuantity,
    setCurrentQuantityInputValue,
    setCurrentQuantityInput,
    openItem,
    currentVariant,
  } = props;

  const compareItems = (a, b) => {
    return b.price - a.price;
  };

  return (
    <Wrapper className="card-box">
      <div className="row mb-2">
        <div className="col-12">
          <h4 className="header-title" style={{ marginBottom: '10px' }}>
            Состав комплекта
          </h4>
        </div>
      </div>
      <div className="row mb-3 d-flex justify-content-between">
        <div className="col-md-3">
          <Button
            type="button"
            text={'Добавить товар в комплект'}
            icon="fe-plus"
            classType="btn btn-light"
            className="ml-auto"
            onClick={() => handleNewItem()}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="fixed-table-container">
            <div className="fixed-table-body">
              {data && (
                <table className="table table-centered">
                  <thead className="thead-light">
                    <tr>
                      <th></th>
                      <th>
                        <div>Наименование</div>
                        <div className="light">{getItemsString(data[0].items.length)}</div>
                      </th>
                      <th></th>
                      <th>
                        <div>Цена</div>
                        <div className="light">
                          Цена комплекта:{' '}
                          {`${numeral(
                            data[0].items.reduce(
                              (acc, elem) => acc + elem.price * elem.quantity,
                              0,
                            ),
                          ).format('0,0.[00]')} ${getCurrencySymbol('RUB')}`}
                        </div>
                      </th>
                      <th>
                        <div>Количество</div>
                        <div className="light">
                          Общ. кол-во: {data[0].items.reduce((acc, elem) => acc + elem.quantity, 0)}
                        </div>
                      </th>

                      <th></th>
                    </tr>
                  </thead>
                  {!loading ? (
                    <tbody>
                      {data[0].items?.sort(compareItems).map((item, i) => (
                        <>
                          <TableRow
                            key={item.variantId}
                            i={i}
                            item={item}
                            currentQuantityInput={currentQuantityInput}
                            currentQuantityInputValue={currentQuantityInputValue}
                            handleToggleQuantityInput={handleToggleQuantityInput}
                            handleUpdateQuantity={handleUpdateQuantity}
                            setCurrentQuantityInputValue={setCurrentQuantityInputValue}
                            setCurrentQuantityInput={setCurrentQuantityInput}
                            handleRemoveItem={handleRemoveItem}
                            isNew={isNew}
                            openItem={openItem}
                          />
                        </>
                      ))}
                    </tbody>
                  ) : null}
                </table>
              )}
              {loading ? (
                <div style={{ width: '100%', position: 'relative', height: '150px ' }}>
                  <SpinnerBlock show={loading} />
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
      {currentVariant?.isFfPhysicalSetSynchronized ? (
        <div className="row" style={{ marginTop: '15px' }}>
          <div className="col-12">
            <AlertBlock
              type="warning"
              message="Если комплект участвовал в заказе или сборочном задании, то его состав нельзя изменить"
            />
          </div>
        </div>
      ) : null}
    </Wrapper>
  );
};

export default DekstopComponent;
